module.exports = __webpack_public_path__ + "static/media/edit.f42449e9.svg";